import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import AddIcon from "@material-ui/icons/Add";
import {
    Button,
    TextField,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Grid,
    Menu,
    List,
    ListItem,
    Typography,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
    Chip,
} from "@material-ui/core";
import { Add, Clear } from "@material-ui/icons";
import axios from "axios";
import { ocrTypes, navPath } from "../../constants";
import { useSnackbar } from "notistack";
import { HV_THEME, HVHeader, HVInput, Card, HVButton, HVSelect, StatusPill, Icons, ContentLoader, ScreenEmpty, Spinner } from "../shared/DesignSystem";

const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(grey[900]),
        backgroundColor: grey[900],
        "&:hover": {
            backgroundColor: grey[900],
        },
        marginLeft: 30,
        marginTop: 20,
        height: 50,
    },
}))(Button);

const useStyles = makeStyles({
    root: {
        minWidth: 275,
        marginBottom: 30,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: "transform 0.15s ease-in-out",
        "&:hover": { transform: "scale3d(1.02, 1.02, 1)" },
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginTop: 12,
    },
    cards: {
        marginTop: 50,
        marginLeft: 25
    },
});
function Home(props) {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [groups, setGroups] = useState([]);
    const [name, setName] = useState("");
    const [type, setType] = useState("card");
    const [classificationType, setClassificationType] = useState("image");
    const [ocr, setOcr] = useState("hv");
    const [translate, setTranslate] = useState(false);
    const [sorting, setSorting] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [openNext, setOpenNext] = useState(false);
    const [projects, setProjects] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [search, setSearch] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(8);

    const [tags, setTags] = useState({
        Untagged: {
            selected: false,
            count: 0,
        },
    });

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [newTagName, setNewTagName] = useState("");
    const [selectedGroupssForTags, setSelectedGroupsForTags] = useState([]);
    const [searchForTags, setSearchForTags] = React.useState('');
    const [projectSearch, setProjectSearch] = React.useState('');
    const [pageForTags, setPageForTags] = React.useState(0);
    const [rowsPerPageForTags, setRowsPerPageForTags] = React.useState(10);
    const [openNewTagDialogForTags, setOpenNewTagDialogForTags] = useState(false);
    const [loading, setLoading] = useState(true);
    const [creating, setCreating] = useState(false);
    const [projectsLoading, setProjectsLoading] = useState(false);


    const filteredGroupsForTags = groups.filter(groups =>
        (groups.name ?? "").toLowerCase().includes(searchForTags.toLowerCase()) || (groups._id ?? "").toLowerCase().includes(searchForTags.toLowerCase())
    );

    const handleProjectSelectForTags = (e, id) => {
        if (e.target.checked) {
            setSelectedGroupsForTags([...selectedGroupssForTags, id]);
        } else {
            setSelectedGroupsForTags(selectedGroupssForTags.filter((item) => item !== id));
        }
    };

    // Handle change page
    const handleChangePageForTags = (event, newPage) => {
        setPageForTags(newPage);
    };

    // Handle change rows per page
    const handleChangeRowsPerPageForTags = event => {
        setRowsPerPageForTags(parseInt(event.target.value, 10));
        setPageForTags(0);
    };


    // Filter the projects based on the popup search input
    const filteredProjects = projects.filter(project =>
        (project.name ?? "").toLowerCase().includes(projectSearch.toLowerCase()) || (project._id ?? "").toLowerCase().includes(projectSearch.toLowerCase())
    );

    // Handle change page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Handle change rows per page
    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const processGroupData = (groups) => {
        if (!groups) return;
        if (groups.length === 0) return;

        const TAGS = {
            Untagged: {
                selected: false,
                count: 0,
            },
        };

        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            if (!group.tags) continue;
            for (let j = 0; j < group.tags.length; j++) {
                if (TAGS[group.tags[j]]) {
                    TAGS[group.tags[j]].count += 1;
                } else {
                    TAGS[group.tags[j]] = {
                        selected: false,
                        count: 1,
                    }
                }
            }
            if (group.tags.length === 0) {
                TAGS["Untagged"].count += 1;
            }
        }
        setTags(TAGS);
    }

    const getGroups = () => {
        axios
            .get("/api/groups/list")
            .then((data) => {
                const list = Array.isArray(data.data) ? data.data : [];
                processGroupData(list);
                setGroups(list);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                enqueueSnackbar('Failed to load groups', { variant: 'error' });
                setLoading(false);
            });
    };

    useEffect(() => {
        getGroups();
    }, []);

    const createGroup = () => {
        setCreating(true);
        const data = {
            name,
            type,
            classificationType,
            status: "created",
            ocr,
            translate,
            sorting,
            projects: selectedProjects,
        };
        axios
            .post("/api/groups/create", data)
            .then(() => {
                enqueueSnackbar("Group created successfully", { variant: "success" });
                setGroups([]);
                setName('');
                setType('card');
                setClassificationType('image');
                setOcr('hv');
                setTranslate(false);
                setSorting(false);
                setOpenNext(false);
                getGroups();
            })
            .catch((e) => {
                enqueueSnackbar(e.response?.data || 'Failed to create group', { variant: "error" });
            })
            .finally(() => setCreating(false));
    };
    const handleName = (e) => {
        setName(e.target.value);
    };

    const handleType = (e) => {
        setType(e.target.value);
        setSelectedProjects([]);
    };

    const handleClassificationType = (e) => {
        setClassificationType(e.target.value);
    }

    const handleOcr = (e) => {
        setOcr(e.target.value);
    }

    const handleTranslate = (e) => {
        setTranslate(e.target.checked)
    }

    const handleSorting = (e) => {
        setSorting(e.target.checked)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOpenNext(false);
        setProjectSearch('');
    };

    const handleBack = () => {
        setOpen(true);
        setOpenNext(false);
        setProjectSearch('');
    };

    const handleNext = () => {
        if (!name.trim()) {
            enqueueSnackbar('Group name is required', { variant: 'error' });
            return;
        }
        getProjects();
        setOpen(false);
        setOpenNext(true);
    };

    const addTagToGroups = (groupIds, tag) => {
        if (groupIds.length === 0) {
            enqueueSnackbar("No groups selected", {
                variant: "error",
            });
            return;
        }
        if (!tag || tag === "") {
            enqueueSnackbar("No tag selected", {
                variant: "error",
            });
            return;
        }
        axios
            .post("/api/groups/addTagToGroups", {
                groupIds,
                tag,
            })
            .then((res) => {
                enqueueSnackbar(res.data, {
                    variant: "success",
                });
                getProjects();
            })
            .catch((e) => {
                enqueueSnackbar(e.response.data, {
                    variant: "error",
                });
            });
    };

    const getProjects = () => {
        setProjectsLoading(true);
        axios
            .get("/api/projects/list?query=all")
            .then((data) => {
                const list = Array.isArray(data.data) ? data.data : [];
                setProjects(list.filter((project) => project.type === type));
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => setProjectsLoading(false));
    };

    const handleProjectSelect = (e, id) => {
        if (e.target.checked) {
            setSelectedProjects([...selectedProjects, id]);
        } else {
            setSelectedProjects(selectedProjects.filter((item) => item !== id));
        }
    };

    const handleClick = (name, docType, groupName, tags) => {
        props.history.push(navPath(`/group/${name}`));
    };

    const [statusFilter, setStatusFilter] = React.useState('all');
    const [typeFilter, setTypeFilter] = React.useState('all');
    const [tagFilter, setTagFilter] = React.useState('all');

    const STATUS_TONE = {
        production: { tone: 'ok', label: 'In production' },
        review: { tone: 'warn', label: 'In review' },
        training: { tone: 'info', label: 'Training' },
        draft: { tone: 'neutral', label: 'Draft' },
        failed: { tone: 'danger', label: 'Failed' },
        locked: { tone: 'purple', label: 'Locked' },
        created: { tone: 'neutral', label: 'Created' },
        database_created: { tone: 'neutral', label: 'Created' }
    };
    const TAG_PALETTE = {
        'Production': { bg: '#e7f5ed', fg: '#0f5d2a', bd: '#b7dfca' },
        'Testing':    { bg: '#e6efff', fg: '#1a3a8a', bd: '#b3c9f7' },
        'In Review':  { bg: '#fdf1dc', fg: '#7a4a07', bd: '#f5d68a' },
    };
    const tagStyle = (tag, active = false) => active
        ? { background: '#000', color: '#fff', border: '1px solid #000' }
        : { background: TAG_PALETTE[tag]?.bg || '#fff', color: TAG_PALETTE[tag]?.fg || HV_THEME.ink, border: '1px solid ' + (TAG_PALETTE[tag]?.bd || '#e0e0e0') };
    const role = {
        name: 'Admin', initials: 'AD', color: '#e6194b', label: 'Admin',
        can: { create: true }
    };

    const filtered = React.useMemo(() => {
        return groups.filter(p => {
            if (search && !(p.name?.toLowerCase().includes(search.toLowerCase()) || p._id.includes(search))) return false;
            if (tagFilter !== 'all') {
                if (tagFilter === 'Untagged' && (!p.tags || p.tags.length === 0)) return true;
                if (tagFilter !== 'Untagged' && (!p.tags || !p.tags.includes(tagFilter))) return false;
            }
            if (typeFilter !== 'all' && p.type !== typeFilter) return false;
            if (statusFilter !== 'all' && p.status !== statusFilter) return false;
            return true;
        });
    }, [search, tagFilter, typeFilter, statusFilter, groups]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / rowsPerPage));
    const pageItems = filtered.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

    const gdlabelStyle = { display: 'block', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: HV_THEME.mute, marginBottom: 6 };
    const gdinputStyle = { width: '100%', height: 38, border: '1px solid #d4d4d4', borderRadius: 2, padding: '0 12px', fontFamily: 'inherit', fontSize: 13, color: HV_THEME.ink, outline: 0, boxSizing: 'border-box' };

    return (
        <div data-screen-label="02 Groups" style={{ background: HV_THEME.bg, minHeight: '100vh', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", color: HV_THEME.ink }}>
            <HVHeader tab="groups" role={role} env="STAGING" onTab={props.onTab} onLogout={props.onLogout} />

            <div style={{ padding: '28px 40px', maxWidth: 1440, margin: '0 auto' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 22 }}>
                    <div>
                        <div style={{ fontSize: 10, letterSpacing: '0.18em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase' }}>Workspace</div>
                        <h1 style={{ fontSize: 28, fontWeight: 700, margin: '6px 0 4px', letterSpacing: '-0.02em' }}>Groups</h1>
                        <div style={{ fontSize: 13, color: HV_THEME.mute }}>{groups.length} total · {filtered.length} matching filters</div>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <HVButton variant="secondary" icon={<Icons.plus size={14} />} onClick={() => setOpenNewTagDialogForTags(true)}>Tag Groups</HVButton>
                        <HVButton variant="primary" icon={<Icons.plus size={14} />} onClick={handleClickOpen}>New group</HVButton>
                    </div>
                </div>

                <Card pad={0} style={{ padding: '14px 16px', marginBottom: 18, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 320px', minWidth: 280 }}>
                        <HVInput
                            icon={<Icons.search size={16} stroke={HV_THEME.mute} />}
                            placeholder="Search by group name or ID…"
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); setPage(0); }}
                            suffix={search && <button onClick={() => setSearch('')} style={{ background: 'transparent', border: 0, cursor: 'pointer', color: HV_THEME.mute, padding: 4 }}><Icons.x size={14} /></button>}
                            style={{ borderColor: '#e0e0e0' }}
                        />
                    </div>
                    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                        <select value={typeFilter} onChange={e => { setTypeFilter(e.target.value); setPage(0); }} style={{ appearance: 'none', border: '1px solid #e0e0e0', background: '#fff', padding: '0 30px 0 12px', height: 38, borderRadius: 2, fontFamily: 'inherit', fontSize: 12, fontWeight: 500, color: HV_THEME.ink, cursor: 'pointer' }}>
                            <option value="all">Type: All</option>
                            <option value="card">CARD</option>
                            <option value="doc">DOCUMENT</option>
                            <option value="passport">PASSPORT</option>
                        </select>
                        <Icons.chevDown size={14} stroke={HV_THEME.mute} style={{ position: 'absolute', right: 10, top: 12, pointerEvents: 'none' }} />
                    </div>
                    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                        <select value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(0); }} style={{ appearance: 'none', border: '1px solid #e0e0e0', background: '#fff', padding: '0 30px 0 12px', height: 38, borderRadius: 2, fontFamily: 'inherit', fontSize: 12, fontWeight: 500, color: HV_THEME.ink, cursor: 'pointer' }}>
                            <option value="all">Status: All</option>
                            {Object.entries(STATUS_TONE).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                        </select>
                        <Icons.chevDown size={14} stroke={HV_THEME.mute} style={{ position: 'absolute', right: 10, top: 12, pointerEvents: 'none' }} />
                    </div>
                    <div style={{ flex: 1 }} />
                </Card>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 11, color: HV_THEME.mute, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', marginRight: 4 }}>Tags</span>
                    <button onClick={() => { setTagFilter('all'); setPage(0); }} style={{ background: tagFilter === 'all' ? '#000' : '#fff', color: tagFilter === 'all' ? '#fff' : HV_THEME.ink, border: '1px solid ' + (tagFilter === 'all' ? '#000' : '#e0e0e0'), borderRadius: 99, padding: '5px 12px', fontSize: 12, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit' }}>
                        All <span style={{ opacity: 0.55, marginLeft: 4 }}>{groups.length}</span>
                    </button>
                    {Object.keys(tags).map(t => {
                        const ts = tagStyle(t, tagFilter === t);
                        return (
                            <button key={t} onClick={() => { setTagFilter(t); setPage(0); }} style={{ ...ts, borderRadius: 99, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                                {t} <span style={{ opacity: 0.55, marginLeft: 4 }}>{tags[t].count}</span>
                            </button>
                        );
                    })}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
                    {loading && <div style={{ gridColumn: '1 / -1' }}><ContentLoader title="Loading groups…" subtitle="Fetching your groups" size="md" /></div>}
                    {!loading && pageItems.length === 0 && <div style={{ gridColumn: '1 / -1' }}><Card pad={0}><div style={{ padding: '60px 20px', textAlign: 'center', color: HV_THEME.mute }}><div style={{ width: 56, height: 56, borderRadius: 99, background: '#f4f4f4', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}><Icons.search size={24} /></div><div style={{ fontSize: 16, fontWeight: 600, color: HV_THEME.ink, marginBottom: 4 }}>{(search || tagFilter !== 'all' || typeFilter !== 'all' || statusFilter !== 'all') ? `No groups match "${search}"` : 'No groups'}</div><div style={{ fontSize: 13 }}>{(search || tagFilter !== 'all' || typeFilter !== 'all' || statusFilter !== 'all') ? 'Try a different search term or clear your filters.' : 'Create your first group to get started.'}</div></div></Card></div>}
                    {!loading && pageItems.map(p => {
                        const tone = STATUS_TONE[p.status] || { tone: 'neutral', label: p.status || 'Created' };
                        return (
                            <Card key={p._id} pad={0} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                <div style={{ padding: 16, paddingBottom: 12 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
                                        <div style={{ width: 40, height: 40, borderRadius: 4, background: p.type === 'card' ? '#eef2ff' : '#fef3e8', color: p.type === 'card' ? '#3949ab' : '#9a4500', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }}>
                                            {p.type === 'card' ? <Icons.image size={18} /> : <Icons.doc size={18} />}
                                        </div>
                                        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                            {p.isLocked && (
                                                <span title="Locked" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#fdf1dc', color: '#7a4a07', borderRadius: 99, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>
                                                    <Icons.lock size={10} stroke="#7a4a07" sw={2.5} />LOCKED
                                                </span>
                                            )}
                                            <StatusPill tone={tone.tone} size="sm">{tone.label}</StatusPill>
                                        </div>
                                    </div>
                                    <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4, lineHeight: 1.3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={p.name}>{p.name}</div>
                                    <div style={{ fontSize: 11, color: HV_THEME.mute, fontFamily: "'JetBrains Mono', monospace", marginBottom: 8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }} onClick={() => {
                                        enqueueSnackbar(`${p._id} copied to clipboard`, { variant: "success", autoHideDuration: 800 });
                                        navigator.clipboard.writeText(p._id);
                                    }}>{p._id} <Icons.copy size={10} /></div>

                                    {p.tags && p.tags.length > 0 && (
                                        <div style={{ display: 'flex', gap: 4, flexWrap: 'nowrap', overflow: 'hidden', marginBottom: 10, alignItems: 'center' }}>
                                            {p.tags.slice(0, 3).map(tag => {
                                                const tp = TAG_PALETTE[tag] || { bg: '#f1f1f1', fg: '#3a3a3a' };
                                                return (
                                                    <span key={tag} style={{ background: tp.bg, color: tp.fg, borderRadius: 99, padding: '2px 8px', fontSize: 10, fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>{tag}</span>
                                                );
                                            })}
                                            {p.tags.length > 3 && (
                                                <span style={{ fontSize: 10, color: HV_THEME.mute, flexShrink: 0 }}>+{p.tags.length - 3}</span>
                                            )}
                                        </div>
                                    )}

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, paddingTop: 10, borderTop: '1px solid #f0f0f0' }}>
                                        <div>
                                            <div style={{ fontSize: 9, letterSpacing: '0.12em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 3 }}>Type</div>
                                            <div style={{ fontSize: 12, fontWeight: 600 }}>{p.type?.toUpperCase()} <span style={{ color: HV_THEME.mute, fontWeight: 400 }}>{p.classificationType}</span></div>
                                            <div style={{ fontSize: 10, color: HV_THEME.mute, marginTop: 1 }}>{p.ocr}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 9, letterSpacing: '0.12em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 3 }}>Updated</div>
                                            <div style={{ fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{new Date(p.updatedAt || Date.now()).toLocaleDateString()}</div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ borderTop: '1px solid #f0f0f0', padding: '10px 12px', display: 'flex', gap: 6, alignItems: 'center', background: '#fafafa', marginTop: 'auto' }}>
                                    <HVButton size="sm" variant="secondary" style={{ flex: 1 }} onClick={() => handleClick(p._id, p.type, p.name, p.tags)}>Open</HVButton>
                                </div>
                            </Card>
                        );
                    })}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 18, padding: '6px 4px' }}>
                    <div style={{ fontSize: 12, color: HV_THEME.mute }}>
                        Showing <strong style={{ color: HV_THEME.ink }}>{filtered.length === 0 ? 0 : page * rowsPerPage + 1}–{Math.min((page + 1) * rowsPerPage, filtered.length)}</strong> of <strong style={{ color: HV_THEME.ink }}>{filtered.length}</strong>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: HV_THEME.mute }}>
                            Rows per page
                            <select value={rowsPerPage} onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }} style={{ border: '1px solid #e0e0e0', background: '#fff', padding: '4px 6px', borderRadius: 2, fontFamily: 'inherit' }}>
                                {[8, 12, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
                            </select>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <button disabled={page === 0} onClick={() => setPage(0)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page === 0 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page === 0 ? '#bbb' : HV_THEME.ink, cursor: page === 0 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>«</button>
                            <button disabled={page === 0} onClick={() => setPage(page - 1)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page === 0 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page === 0 ? '#bbb' : HV_THEME.ink, cursor: page === 0 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icons.chevL size={13} /></button>
                            <span style={{ fontSize: 12, fontWeight: 600, margin: '0 8px' }}>Page {page + 1} of {totalPages}</span>
                            <button disabled={page >= totalPages - 1} onClick={() => setPage(page + 1)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page >= totalPages - 1 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page >= totalPages - 1 ? '#bbb' : HV_THEME.ink, cursor: page >= totalPages - 1 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icons.chevR size={13} /></button>
                            <button disabled={page >= totalPages - 1} onClick={() => setPage(totalPages - 1)} style={{ minWidth: 32, height: 32, padding: '0 8px', borderRadius: 2, border: '1px solid ' + (page >= totalPages - 1 ? '#e0e0e0' : '#e0e0e0'), background: '#fff', color: page >= totalPages - 1 ? '#bbb' : HV_THEME.ink, cursor: page >= totalPages - 1 ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>»</button>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="create-group" maxWidth="xs" fullWidth>
                <DialogTitle id="create-group" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", fontWeight: 700, fontSize: 18, borderBottom: '1px solid #f0f0f0', position: 'relative', paddingRight: 48, paddingBottom: 16 }}>
                    Create new group
                    <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", paddingTop: 20 }}>
                    <div style={{ marginBottom: 14 }}>
                        <label style={gdlabelStyle}>Group Name <span style={{ color: HV_THEME.danger }}>*</span></label>
                        <input
                            autoFocus
                            value={name}
                            onChange={handleName}
                            placeholder="e.g. Passport Group"
                            style={{ ...gdinputStyle, borderColor: name.trim() ? '#d4d4d4' : '#e0a0a0' }}
                        />
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={gdlabelStyle}>Type</label>
                        <HVSelect value={type} onChange={handleType}>
                            <option value="card">Card</option>
                            <option value="doc">Document</option>
                            <option value="passport">Passport</option>
                        </HVSelect>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={gdlabelStyle}>Classification</label>
                        <HVSelect value={classificationType} onChange={handleClassificationType}>
                            <option value="text">Text</option>
                            <option value="keyword">Keyword</option>
                            <option value="image">Image</option>
                        </HVSelect>
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={gdlabelStyle}>OCR Type</label>
                        <HVSelect value={ocr} onChange={handleOcr}>
                            {Object.keys(ocrTypes).map((o) => <option key={o} value={o}>{ocrTypes[o]}</option>)}
                        </HVSelect>
                    </div>
                    <div style={{ display: 'flex', gap: 20, marginTop: 4 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                            <input type="checkbox" checked={translate} onChange={handleTranslate} style={{ width: 15, height: 15, accentColor: '#000', cursor: 'pointer' }} />
                            Enable Translation
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer', userSelect: 'none' }}>
                            <input type="checkbox" checked={sorting} onChange={handleSorting} style={{ width: 15, height: 15, accentColor: '#000', cursor: 'pointer' }} />
                            Enable Sorting
                        </label>
                    </div>
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handleClose}>Cancel</HVButton>
                    <HVButton variant="primary" onClick={handleNext} disabled={!name.trim()}>Next</HVButton>
                </DialogActions>
            </Dialog>
            <Dialog open={openNext} onClose={handleClose} aria-labelledby="create-group-projects" fullWidth maxWidth="md">
                <DialogTitle id="add-projects" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", fontWeight: 700, fontSize: 18, borderBottom: '1px solid #f0f0f0', position: 'relative', paddingRight: 48, paddingBottom: 16 }}>
                    Add projects
                    <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <Icons.x size={18} />
                    </IconButton>
                </DialogTitle>
                <div style={{ padding: '16px 24px 0', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
                    <HVInput
                        icon={<Icons.search size={15} stroke={HV_THEME.mute} />}
                        placeholder="Search projects…"
                        value={projectSearch}
                        onChange={e => setProjectSearch(e.target.value)}
                        suffix={projectSearch && <button onClick={() => setProjectSearch('')} style={{ background: 'transparent', border: 0, cursor: 'pointer', color: HV_THEME.mute, padding: 4 }}><Icons.x size={13} /></button>}
                    />
                    {selectedProjects.length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 12 }}>
                            {selectedProjects.map((id) => {
                                const proj = projects.find(p => p._id === id);
                                return (
                                    <span key={id} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#f1f1f1', borderRadius: 99, padding: '3px 10px', fontSize: 12, fontWeight: 500 }}>
                                        {proj ? proj.name : id}
                                        <button onClick={() => setSelectedProjects(selectedProjects.filter(s => s !== id))} style={{ background: 'transparent', border: 0, cursor: 'pointer', color: HV_THEME.mute, padding: 0, display: 'flex', alignItems: 'center' }}><Icons.x size={11} /></button>
                                    </span>
                                );
                            })}
                        </div>
                    )}
                </div>
                <DialogContent style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", paddingTop: 12 }}>
                    {projectsLoading ? (
                        <ContentLoader size="sm" />
                    ) : filteredProjects.length === 0 ? (
                        <div style={{ padding: '32px 0', textAlign: 'center', color: HV_THEME.mute, fontSize: 13 }}>No projects found for this type</div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                                {filteredProjects.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((project) => (
                                    <tr key={project._id} style={{ borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }} onClick={() => handleProjectSelect({ target: { checked: !selectedProjects.includes(project._id) } }, project._id)}>
                                        <td style={{ padding: '10px 4px' }}>
                                            <div style={{ fontSize: 13, fontWeight: 600 }}>{project.name}</div>
                                            <div style={{ fontSize: 11, color: HV_THEME.mute, fontFamily: "'JetBrains Mono', monospace", marginTop: 2 }}>{project._id}</div>
                                        </td>
                                        <td style={{ padding: '10px 4px', textAlign: 'right', width: 40 }}>
                                            <input type="checkbox" checked={selectedProjects.includes(project._id)} onChange={() => {}} style={{ width: 15, height: 15, accentColor: '#000', cursor: 'pointer' }} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                    {!projectsLoading && filteredProjects.length > rowsPerPage && (
                        <TablePagination component="div" count={filteredProjects.length} page={page} onChangePage={handleChangePage} rowsPerPage={rowsPerPage} onChangeRowsPerPage={handleChangeRowsPerPage} />
                    )}
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', gap: 8 }}>
                    <HVButton variant="ghost" onClick={handleClose}>Cancel</HVButton>
                    <HVButton variant="secondary" onClick={handleBack}>Back</HVButton>
                    <HVButton variant="primary" onClick={createGroup} disabled={creating} icon={creating ? <Spinner size={14} color="#fff" /> : null}>
                        {creating ? 'Creating…' : 'Create'}
                    </HVButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openNewTagDialogForTags}
                onClose={() => setOpenNewTagDialogForTags(false)}
                aria-labelledby="create-group-projects"
                fullWidth={true}
                maxWidth='md'
            >
                <DialogTitle id="add-group-tag">Select groups</DialogTitle>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'start',
                    marginLeft: 25,
                    marginBottom: 20
                }}>
                    <Button aria-controls="simple-menu" aria-haspopup="true" onClick={(event) => setAnchorEl(event.currentTarget)}>
                        Select existing tag
                    </Button>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={(event) => setAnchorEl(null)}
                    >
                        {Object.keys(tags).filter((tag) => tag !== "Untagged").map((tag) => (
                            <MenuItem
                                onClick={() => {
                                    setNewTagName(tag);
                                    setAnchorEl(null);
                                }}
                            >
                                {tag}
                            </MenuItem>
                        ))}
                    </Menu>
                    <TextField
                        required
                        margin="normal"
                        id="tag"
                        label="Enter a new Tag"
                        type="text"
                        variant="outlined"
                        value={newTagName}
                        onChange={(e) => setNewTagName(e.target.value)}
                        style={{ marginLeft: 25, marginRight: 25 }}
                    />
                    {
                        newTagName && !Object.keys(tags).includes(newTagName) ? "(New Tag)" : ""
                    }
                </div>
                <TextField
                    label="Search"
                    variant="outlined"
                    value={searchForTags}
                    style={{ marginLeft: 25, marginRight: 25 }}
                    onChange={e => setSearchForTags(e.target.value)}
                />
                <div style={{ marginLeft: 25, marginTop: 20 }}>
                    {selectedGroupssForTags.map((group, index) => (
                        <Chip key={index} label={group} title={group} style={{ marginRight: 10, marginTop: 10 }} />
                    ))}
                </div>
                <DialogContent>
                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            {filteredGroupsForTags.length === 0
                                ? "No Groups Found"
                                : filteredGroupsForTags.slice(pageForTags * rowsPerPageForTags, pageForTags * rowsPerPageForTags + rowsPerPageForTags).map((group, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                            <Typography>
                                                {group.name}
                                            </Typography>
                                            <Typography className={classes.pos} color="textSecondary">
                                                Id: {group._id}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Checkbox
                                                checked={selectedGroupssForTags.includes(group._id)}
                                                onChange={(e) => handleProjectSelectForTags(e, group._id)}
                                                inputProps={{ "aria-label": "primary checkbox" }}
                                                required
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        count={filteredGroupsForTags.length}
                        page={pageForTags}
                        onChangePage={handleChangePageForTags}
                        rowsPerPage={rowsPerPageForTags}
                        onChangeRowsPerPage={handleChangeRowsPerPageForTags}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpenNewTagDialogForTags(false) }} variant="contained" color="secondary">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            addTagToGroups(selectedGroupssForTags, newTagName);
                            setOpenNewTagDialogForTags(false);
                            setNewTagName("");
                            setSelectedGroupsForTags([]);
                            setSearchForTags("");
                        }}
                        className="btn btn-primary"
                    >Add</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Home
